import { Box } from '@chakra-ui/react';
import { selectHasShowMargin } from 'modules/Editor/store/editorSettingsSelector';
import { useAppSelector } from 'modules/Editor/store/hooks';
import { memo } from 'react';

// same as E1
const MARGIN_WIDTH_OFFSET = 96;
const MARGIN_POSITION_OFFSET = 48;
const MARGIN_COLOR = 'rgba(102, 102, 102, 1)';
const testId = 'margin-overlay-container';

export const MarginOverlay = memo(() => {
  const hasShowMargin = useAppSelector(selectHasShowMargin);
  if (!hasShowMargin) return null;

  const size = `calc(100% - ${MARGIN_WIDTH_OFFSET}px)`;
  const positionOffset = `${MARGIN_POSITION_OFFSET}px`;

  return (
    <Box
      zIndex='margin'
      position='absolute'
      border='1px solid'
      borderColor={MARGIN_COLOR}
      w={size}
      left={positionOffset}
      top={positionOffset}
      h={size}
      pointerEvents='none'
      data-testid={testId}
    />
  );
});
MarginOverlay.displayName = 'MarginOverlay';
